import React from "react";
import "./PasswordAndSecurityButton.css";
import right2 from "../../img/right@2x.svg"
import vect2 from "../../img/securityLogo.png"
import Link from "../Link";


const PasswordAndSecurityButton = (props) => {
    const { className, logo } = props;

    return (
        <Link href="/password-and-security">
            <div className="passwords-security-button">
                <img className="vector-42" src={`${logo || vect2}`} />
                <div className="group-1000005018">
                    <div className={`password-security ${className || "nunito-bold-black-14px"}`}>Password &amp; Security</div>
                    <img className="right-2" src={right2} />
                </div>
            </div>
        </Link>
    );
}

export default PasswordAndSecurityButton;